import once from 'lodash/once';

const fetchManifest = () => {
  const appManifestURL = `${window.top!.TLGLOBALS.WEB_MANIFEST}?t=${Date.now()}`;
  return fetch(appManifestURL).then((response) => response.json());
};
/**
 * Makes sure loadManifest doesn't get called multiple times
 * to avoid duplicate requests
 */
export const getManifest = once(fetchManifest);
